module.exports = __webpack_public_path__ + "540d5ddd6eaa1619c87357856a9f9f47.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/sound.png
// module id = 245
// module chunks = 0